import { isFuture } from 'date-fns';
import { getCurrentMonthlyCycleDate } from 'src/components/oneCorp/features/MealCredit/utils/mealCreditDataUtils/getCurrentMonthlyCycleDate';
import { isDateValidAndPast } from 'src/components/oneCorp/features/MealCredit/utils/isDateValidAndPast';
import { MealCreditInfoTextProps } from './constructMealCreditInfoText.utils';
import { getCurrentPeriodStartDate } from './getCurrentPeriodStartDate';

export function calculateStartDate(
  props: Pick<
    MealCreditInfoTextProps,
    | 'startDate'
    | 'isRepeating'
    | 'expirationDate'
    | 'refreshPeriodDaysCount'
    | 'refreshPeriodMonthsCount'
    | 'isMonthAvailable'
  >
): Date {
  const {
    startDate,
    isRepeating,
    expirationDate,
    refreshPeriodDaysCount,
    refreshPeriodMonthsCount,
    isMonthAvailable,
  } = props;

  if (isDateValidAndPast(expirationDate)) {
    return startDate;
  }

  if (isMonthAvailable) {
    return getCurrentMonthlyCycleDate({
      firstInstanceDate: startDate,
      currentDate: new Date(),
      refreshPeriodMonthsCount,
    });
  }

  if (!isRepeating) {
    return startDate;
  }

  if (isFuture(startDate)) {
    return startDate;
  }

  return getCurrentPeriodStartDate({ startDate, refreshPeriodDaysCount });
}
